import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1ab0616"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Leads", -1))
const _hoisted_2 = {
  key: 0,
  class: "info-message"
}
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("New Lead")
const _hoisted_5 = { class: "row form-group" }
const _hoisted_6 = ["onKeyup"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Name")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Phone Number")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Email")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Referral")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Desired Move-In")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Status")
], -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Notes", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 4,
  class: "text-center",
  style: {"margin-top":"15px"}
}
const _hoisted_23 = {
  key: 5,
  class: "error-message"
}
const _hoisted_24 = {
  key: 6,
  class: "modal-backdrop"
}
const _hoisted_25 = { class: "modal" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Complete Lead", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Mark ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" as complete? ")

import { computed, onMounted, ref } from "vue";

import { get } from "../../src/methods/api";
import api from "@virgodev/bazaar/functions/api";

import { LeadInterface } from "@/types/customers";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { UnitInterface } from "@/types/unit";
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
type HiddenLeadRecord = { lead_id: string };
type AggregatedError = {
  facilityId?: string;
  provider?: string;
  status?: number | string;
};
type AggregatedResult = {
  facilityId: string;
  provider?: string;
  leads?: LeadInterface[];
};

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityName: {
    type: String,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const status = ref("loading");
const searchCustomer = ref("");
const customers = ref(Array<LeadInterface>());
const filteredCustomers = ref();
const errors = ref("");
const units = ref(Array<UnitInterface>());
const hiddenLeadIds = ref<Array<string>>([]);
const storedge = ref(false);
const selectedFilter = ref("name");
const showConfirm = ref(false);
const pendingLead = ref<LeadInterface | null>(null);
const filterOptions = ref([
  { text: "Name", value: "name" },
  { text: "Phone or Cell Phone", value: "phone" },
]);

const unsupportedFacility = computed(() => {
  const name = props.facilityName ? props.facilityName.toUpperCase() : "";
  return name === "ESS" || name === "SITELINK";
});

// Facilities without a leads concept (CC Storage) show a plain notice instead
// of loading an aggregate that would only error — driven by the per-provider
// show_leads flag rather than a facility-name check.
const notUtilized = computed(() => !api_settings.show_leads);

onMounted(async () => {
  // Determine provider context and load leads on page mount
  errors.value = "";
  const facility = props.facilityName ? props.facilityName.toLowerCase() : "";
  if (facility === "Storedge") {
    storedge.value = true;
  }
  if (notUtilized.value) {
    status.value = "completed";
    return;
  }
  if (unsupportedFacility.value) {
    errors.value = "Leads are not supported for this facility. ";
    status.value = "completed";
    return;
  }
  await getCustomers();
});


async function getUnits() {
  errors.value = "";
  const response = await api({
    url: `units/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function search() {
  // Local, in-memory filtering for leads table
  if (searchCustomer.value.length) {
    const searchValue = searchCustomer.value.trim().toLowerCase();
    const digitSearch = searchValue.replace(/\D/g, "");
    const contains = (val: unknown) => {
      if (val === undefined || val === null) return false;
      return String(val).toLowerCase().includes(searchValue);
    };

    if (selectedFilter.value == "name") {
      filteredCustomers.value = customers.value.filter(
        (item: LeadInterface) => {
          const first = item.first_name || "";
          const last = item.last_name || "";
          const full = `${first} ${last}`.trim();
          return (
            contains(first) ||
            contains(last) ||
            contains(full) ||
            contains(item.email) ||
            contains(item.source)
          );
        }
      );
    } else {
      if (storedge.value) {
        filteredCustomers.value = customers.value.filter(
          (item: LeadInterface) => {
            // Storedge returns phone_numbers; check both formatted/unformatted
            const nums = (item.phone_numbers || []).map(
              (num) => num.unformatted_number || num.formatted_number || ""
            );
            const digitNums = nums.map((n) => n.replace(/\D/g, ""));
            if (digitSearch) {
              return digitNums.some((n) => n.includes(digitSearch));
            }
            const joined = nums.join(" ").toLowerCase();
            return contains(joined);
          }
        );
      } else {
        filteredCustomers.value = customers.value.filter(
          (item: LeadInterface) => {
            const phone = item.phone || "";
            const cell = item.cell_phone || "";
            // Some providers also return phone_numbers; include them in search
            const extraNums = (item.phone_numbers || []).map(
              (num) => num.unformatted_number || num.formatted_number || ""
            );
            const phoneDigits = phone.replace(/\D/g, "");
            const cellDigits = cell.replace(/\D/g, "");
            const extraDigits = extraNums.map((n) => n.replace(/\D/g, ""));
            if (digitSearch) {
              return (
                phoneDigits.includes(digitSearch) ||
                cellDigits.includes(digitSearch) ||
                extraDigits.some((n) => n.includes(digitSearch)) ||
                contains(item.email)
              );
            }
            const numsJoined = [phone, cell, ...extraNums].join(" ");
            return contains(numsJoined) || contains(item.email);
          }
        );
      }
    }
  } else {
    filteredCustomers.value = customers.value;
  }
}
async function getCustomers() {
  // Load hidden lead IDs for filtering
  const hiddenResp = await get(
    `hidden_leads/?facilityId=${props.facilityId || ""}`
  );
  if (Array.isArray(hiddenResp)) {
    hiddenLeadIds.value = hiddenResp
      .map((item: HiddenLeadRecord) => item.lead_id)
      .filter(Boolean);
  } else {
    hiddenLeadIds.value = [];
  }

  await getUnits();

  const response = await get(
    `aggregate_leads/?facilityIds=${props.facilityId || ""}`
  );
  if (!response) {
    errors.value =
      "Unable to communicate with the server. Please check your connection and try again.";
    status.value = "completed";
    return;
  }

  const results: AggregatedResult[] = Array.isArray(response.results)
    ? (response.results as AggregatedResult[])
    : [];
  const errs: AggregatedError[] = Array.isArray(response.errors)
    ? (response.errors as AggregatedError[])
    : [];
  if (errs.length) {
    errors.value = errs
      .map(
        (err: AggregatedError) =>
          `${err.facilityId || ""} (${err.provider || "unknown"}): ${String(
            err.status || "error"
          )}`
      )
      .join("; ");
  } else {
    errors.value = "";
  }

  // Flatten aggregated leads and carry facility/provider context
  customers.value = results.flatMap((res: AggregatedResult) => {
    const provider = (res.provider || props.facilityName || "").toLowerCase();
    if (provider === "storedge") {
      storedge.value = true;
    }
    const leads: LeadInterface[] = res.leads || [];
    return leads.map((lead: LeadInterface) => ({
      ...lead,
      provider,
      facility_id: res.facilityId,
    }));
  });

  // Filter out locally hidden leads
  if (hiddenLeadIds.value.length) {
    const hiddenSet = new Set(hiddenLeadIds.value);
    customers.value = customers.value.filter(
      (lead: LeadInterface) => !hiddenSet.has(lead.lead_id || lead.id)
    );
  }

  // Attach rentals info to each lead/customer when available
  for (let customer of customers.value) {
    customer.rentals = null;
    let rental_list = units.value.filter(
      (item: UnitInterface) => item.customer_id == Number(customer.id)
    );
    if (storedge.value) {
      rental_list = units.value.filter(
        (item: UnitInterface) => item.current_tenant_id == Number(customer.id)
      );
    }
    if (rental_list) {
      let rental_names = [];
      for (let rental of rental_list) {
        rental_names.push(rental.name);
      }
      customer.rentals = rental_names.join(", ");
    }
  }
  filteredCustomers.value = customers.value;
  status.value = "completed";
}

const pendingLeadName = computed(() => {
  if (!pendingLead.value) return "";
  return [pendingLead.value.first_name, pendingLead.value.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
});

function openConfirm(lead: LeadInterface) {
  pendingLead.value = lead;
  showConfirm.value = true;
}

function closeConfirm() {
  showConfirm.value = false;
  pendingLead.value = null;
}

async function confirmComplete() {
  if (!pendingLead.value) return;
  const lead = pendingLead.value;
  try {
    // Retire upstream when supported; ignore failures
    try {
      await api({
        url: "retire_lead/",
        method: "PUT",
        json: {
          lead_id: lead.lead_id || lead.id,
          contact_id: lead.id,
          property_id: props.facilityId,
          note: "Completed from portal",
        },
        params: { facilityId: props.facilityId },
      });
    } catch (e) {
      // continue to local hide even if retire fails
    }

    // Log locally for audit/recovery
    await api({
      url: "hidden_leads/",
      method: "POST",
      json: {
        lead_id: lead.lead_id || lead.id,
        facility_id: props.facilityId,
        provider: props.facilityName,
        first_name: lead.first_name,
        last_name: lead.last_name,
        email: lead.email,
        phone:
          lead.phone_numbers && lead.phone_numbers.length
            ? lead.phone_numbers[0].formatted_number
            : null,
        desired_unit: lead.desired_unit,
        desired_move_in_date: lead.desired_move_in_date,
        source: lead.source,
        status: lead.status,
        snapshot: lead,
      },
    });
    customers.value = customers.value.filter(
      (item) => (item.lead_id || item.id) !== (lead.lead_id || lead.id)
    );
    filteredCustomers.value = filteredCustomers.value.filter(
      (item: LeadInterface) =>
        (item.lead_id || item.id) !== (lead.lead_id || lead.id)
    );
    closeConfirm();
  } catch (e) {
    errors.value = "Unable to complete lead. Please try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(notUtilized))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " This facility does not utilize leads. "))
      : _createCommentVNode("", true),
    (!_unref(notUtilized))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (
        __props.facilityName == 'Cubby' ||
        __props.facilityName == 'Storedge' ||
        __props.facilityName == 'Tenant_Inc'
      )
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                class: "btn",
                to: {
        name: 'lead_create',
        params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
      }
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchCustomer).value = $event)),
              type: "text",
              style: {"max-width":"840px"},
              onKeyup: _withKeys(search, ["enter"])
            }, null, 40, _hoisted_6), [
              [_vModelText, searchCustomer.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedFilter).value = $event)),
              class: "form-select",
              style: {"max-width":"210px"}
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (filter) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: filter + 'filter',
                  value: filter.value
                }, _toDisplayString(filter.text), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedFilter.value]
            ]),
            _createElementVNode("button", {
              class: "btn",
              onClick: search
            }, "Search")
          ])
        ]))
      : _createCommentVNode("", true),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 2,
          preset: "large"
        }))
      : _createCommentVNode("", true),
    (filteredCustomers.value && filteredCustomers.value.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
          _createElementVNode("tr", null, [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            (!storedge.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCustomers.value, (customer) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: (customer.lead_id || customer.id) + 'customer'
            }, [
              _createElementVNode("td", null, [
                (customer.id || customer.lead_id)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      to: {
            name:
              (customer.provider || __props.facilityName || '').toLowerCase() === 'ess'
                ? 'customer_detail_ess'
                : 'customer_detail_storedge',
            params: {
              id: customer.id || customer.lead_id,
              facilityId: customer.facility_id || __props.facilityId,
              contactId: customer.id || customer.lead_id,
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                    ], 64))
              ]),
              (customer.phone_numbers)
                ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.phone_numbers, (phone) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: phone.id + 'phone'
                      }, [
                        _createTextVNode(_toDisplayString(phone.formatted_number) + " - " + _toDisplayString(phone.label), 1),
                        _hoisted_19
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("td", null, _toDisplayString(customer.phone), 1),
                    _createElementVNode("td", null, _toDisplayString(customer.cell_phone), 1)
                  ], 64)),
              _createElementVNode("td", null, _toDisplayString(customer.email), 1),
              _createElementVNode("td", null, _toDisplayString(customer.source || "—"), 1),
              _createElementVNode("td", null, _toDisplayString(customer.desired_move_in_date || "-"), 1),
              _createElementVNode("td", null, _toDisplayString(customer.status || "—"), 1),
              (!storedge.value)
                ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(customer.notes || "—"), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-blue",
                onClick: ($event: any) => (openConfirm(customer))
              }, " Complete ", 8, _hoisted_21)
            ]))
          }), 128))
        ]))
      : (status.value == 'completed' && !_unref(notUtilized))
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " No results found "))
        : _createCommentVNode("", true),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true),
    (showConfirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("p", null, [
              _hoisted_27,
              _createElementVNode("strong", null, _toDisplayString(_unref(pendingLeadName) || "this lead"), 1),
              _hoisted_28
            ]),
            _createElementVNode("div", {
              class: "row horizontal-end",
              style: {"gap":"10px"}
            }, [
              _createElementVNode("button", {
                class: "btn btn-white",
                onClick: closeConfirm
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn btn-blue",
                onClick: confirmComplete
              }, "Confirm")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})